export var TestimonialView;
(function (TestimonialView) {
    TestimonialView["BOOKER"] = "booker";
    TestimonialView["VENDOR"] = "vendor";
})(TestimonialView || (TestimonialView = {}));
export const socialSharingOptions = [
    {
        name: 'facebook',
        social: true,
        iconName: 'fa-brands fa-facebook fa-lg pre-icon'
    },
    {
        name: 'twitter',
        social: true,
        iconName: 'fa-brands fa-x-twitter fa-lg pre-icon'
    },
    {
        name: 'linkedin',
        social: true,
        iconName: 'fa-brands fa-linkedin fa-lg pre-icon'
    },
    {
        name: 'copy',
        social: false,
        iconName: 'fa-solid fa-copy fa-lg pre-icon'
    },
    {
        name: 'email',
        social: true,
        iconName: 'fa-solid fa-envelope fa-lg pre-icon'
    }
];
export const homeInfoBlocks = [
    {
        name: 'why_asq',
        icon: 'fa-solid fa-block-question',
        img: '/img/brand/info-why.jpg',
        alt: 'Art room'
    },
    {
        name: 'online_booking',
        icon: 'fa-sharp fa-solid fa-globe',
        img: '/img/brand/info-online.jpg',
        alt: 'Online booking'
    },
    {
        name: 'meeting_venues',
        icon: 'fa-regular fa-map-location',
        img: '/img/brand/info-venues.jpg',
        alt: 'Meeting venues'
    },
    {
        name: 'professional_meetings',
        icon: 'fa-solid fa-user-tie',
        img: '/img/brand/info-professional.jpg',
        alt: 'Professional meetings'
    }
];
